import React from 'react';
import Container from '@material-ui/core/Container';
import ZazzleInvoices from 'pages/zazzle-invoices/ZazzleInvoices';

const ZazzleInvoicesTabs = () => {
  return (
    <Container>
      <ZazzleInvoices />
    </Container>
  );
};

export default ZazzleInvoicesTabs;
